<template>
  <div>
    <the-page
      :pageId="pageId" :appConfig="appConfig" class="catalog-classifier"
      embeddedMode
    >
      <div class="catalog-classifier__wrapper">
        <page-block class="catalog-classifier__main" :isLoading="isLoading">
          <a-alert
            v-if="!isLoading && !config" message="Конфиг не найден" type="info"
            showIcon
          />

          <div v-else>
            <elastic
              :config="es_config"
              :appConfig="appConfig"
              :mainIndex="mainIndex"
              showSearch
              :versions="versions"
              :updateButton="canUpdateCatalog"
            >
              <template #title>
                <page-title :title="title" />
              </template>
            </elastic>
          </div>
        </page-block>
      </div>
    </the-page>
  </div>
</template>

<script>
import axios from 'axios';
import ThePage from '@/components/page/ThePage.vue';
import PageBlock from '@/components/page/PageBlock.vue';
import PageTitle from '@/components/page/PageTitle';
import Elastic from '@/components/data/elastic/Elastic.vue';
import store from '@/store';

const esUrl = process.env.VUE_APP_ELASTIC_URL;

export default {
  name: 'CatalogClassifierPage',

  components: {
    Elastic,
    ThePage,
    PageBlock,
    PageTitle,
  },

  props: {
    appConfig: {
      type: Object,
      default: null,
    },
    technicalName: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    mainIndex: {
      type: String,
      required: false,
      default: null,
    },
    canUpdateCatalog: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  data() {
    return {
      loading: true,
      data: null,
      catalog: [],
      title: '',
      versions: []
    };
  },

  computed: {
    config() {
      return (
        store.state.activeSidebarItem?.customprops.tableRowLinkedComponent ||
        store.state.activeSidebarItem
      );
    },
    es_config() {
      return {
        sourceType: 'elastic',
        sourceId: this.technicalName,
      };
    },
    pageId() {
      return this.$route.params.type;
    },
    isLoading() {
      return this.loading || this.config === undefined;
    },
  },

  async mounted() {
    this.requestData();
  },

  methods: {
    async requestData() {
      if (!this.technicalName) return;
      this.loading = true;

      const query = {
        size: 10000,
        from: 0,
      };
      const url = this.mainIndex ? this.mainIndex : this.type;
      let catalog = await this.axios.post(`${esUrl}/${url}/_search`, query, {
        cancelToken: axios.CancelToken.source().token,
      });
      catalog = catalog?.data?.hits.hits;
      this.classifier = catalog.find(
        (el) => el._source.technical_name === this.technicalName,
      )?._source;
      this.versions = [this.classifier?.version]

      this.title = this.classifier?.long_name || this.technicalName;
      if (!this.classifier) {
        this.$router.push({
          name: 'DataPage',
          params: {
            pageId: 'catalog',
          },
        });
      }
      this.loading = false;
    },
  },
};
</script>
